import { addMinutes, format, parseISO } from "date-fns";
import { zonedTimeToUtc } from "date-fns-tz";
import au from "date-fns/locale/en-AU";

/**
 * Parses the given UTC date string to a Date object.
 * @param datetime The date string to parse.
 */
export const parseUTCDate = (datetime: string): Date =>
	zonedTimeToUtc(parseISO(datetime), "UTC");

/**
 * Formats the given Date object to the Australian locale, in the browser's
 * timezone.
 * @param datetime The date to format.
 */
export const formatUTCDate = (datetime: Date): string =>
	format(datetime, "PPPPpp", { locale: au });

/**
 * Return the given `datetime` string as a formatted string. The given
 * `datetime` is in UTC.
 */
export const formatDateStr = (datetime: string): string =>
	formatUTCDate(parseUTCDate(datetime));

export const formatUTCDateStringToLocalISO = (datetime: string): string => {
	const d = parseUTCDate(datetime);
	// We omit seconds and milliseconds because they're not supported in most
	// places in the frontend.
	return format(d, "yyyy-MM-dd'T'HH:mm");
};

export const formatDateForMUI = (datetime: string): string =>
	format(parseISO(datetime), "yyyy-MM-dd'T'HH:mm:ss");

export const formatDateForAPI = (datetime: string): string => {
	const d = parseISO(datetime);
	const offset = d.getTimezoneOffset();

	const utc =
		Math.sign(offset) === -1
			? addMinutes(d, offset)
			: addMinutes(d, offset * -1);
	const res = utc.toISOString();

	// remove the trailing z
	return res.substring(0, res.length - 1);
};
